export const assetCategories = [
  { id: "1", name: "Computer Hardware" },
  { id: "2", name: "Furniture" },
  { id: "3", name: "Medical Equipment" },
  { id: "4", name: "Office Equipment" },
  { id: "5", name: "Vehicle" },
  { id: "6", name: "Building" },
  { id: "7", name: "Other" },
];

export const assetConditions = [
  { id: "1", name: "New" },
  { id: "2", name: "Excellent" },
  { id: "3", name: "Good" },
  { id: "4", name: "Fair" },
  { id: "5", name: "Poor" },
  { id: "6", name: "Damaged" },
];

export const ledgerPostingReferences = [
  { value: "depoNo", label: "DEPOSIT SLIP NO." },
  { value: "chequeNo", label: "CHEQUE NO." },
  { value: "posNo", label: "POINT OF SALE-(POS-Terminal) NO." },
  { value: "pvNo", label: "PAYMENT VOUCHER NO." },
  { value: "trfNo", label: "TRANSFER REFERENCE" },
  { value: "recNo", label: "RECEIPT NO." },
];
